import PropTypes from 'prop-types';

const pinStyle = {
  cursor: 'pointer',
  pointerEvents: 'auto',
};

const MapPin = ({ fill='#FED844', stroke='#052B52', width=38, height=46, ariaLabel='', onClick, inshape='circle' }) => {
  return (
    <svg
      //
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 38 46"
      style={{ ...pinStyle }}
      width={width}
      height={height}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      <defs>
        <path
          d="M14.559342,0.5 C22.3119709,0.5 28.6186841,6.80815039 28.6186841,14.5638185 C28.6186841,19.0794549 26.1842032,23.9700818 22.3179433,28.7983112 C20.8897129,30.5816692 19.4210949,32.161785 18.0126073,33.5151578 C16.1094154,35.345298 15.4560851,35.777858 14.7272943,35.785573 L14.4966709,35.785573 L14.3808607,35.7719761 L14.1928473,35.727211 L13.8086576,35.6357373 L13.808,35.558 L13.7747206,35.5411791 C12.2584528,34.706741 9.18437399,31.5807051 7.06942464,29.0044041 L6.8740349,28.7645731 C2.96238526,23.9332566 0.5,19.0529458 0.5,14.559342 C0.5,6.80743168 6.80743168,0.5 14.559342,0.5 Z"
          id="map-pin-shapes"
        />
        <style> {`path:hover {opacity: .8;}`} </style>
        <filter x="-38.7%" y="-16.0%" width="177.4%" height="164.2%" filterUnits="objectBoundingBox" id="filter-2">
          <feOffset dx="0" dy="6" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0" type="matrix" in="shadowBlurOuter1" />
        </filter>
      </defs>
      <g id="Search" stroke={stroke} strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="All-Legends" transform="translate(-287, -45)" fillRule="nonzero">
          <g id="Group-10" transform="translate(292.71, 45)">
            <g id="Shape-Copy-12">
              <use fill="black" fillOpacity="1" filter="url(#filter-2)" xlinkHref="#map-pin-shapes" />
              <use fill={fill} xlinkHref="#map-pin-shapes" />
            </g>
            <ShapeComponent shape={inshape} />
          </g>
        </g>
      </g>
    </svg>
  );
};

MapPin.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  ariaLabel: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  inshape: PropTypes.string,
};

const ShapeComponent = ({ shape="circle" }) => {
  return (
    <>
      {shape === 'polygon' && (
        <polygon
          transform="translate(-2, -2) scale(1.2, 1.2)"
          id="Polygon"
          fill="#FFFFFF"
          points="13.79 5 21.8739804 10.8733555 18.7861746 20.3766445 8.79382536 20.3766445 5.70601961 10.8733555"
        />
      )}
      {shape === 'rect' && (
        <rect
          transform="translate(-3, -2) scale(1.2, 1.2)"
          id="Rectangle-Copy-4"
          fill="#FFFFFF"
          x="10.65842105"
          y="7.5"
          width="8"
          height="14"
        />
      )}
      {shape === 'ellipse' && (
        <ellipse id="Oval-Copy-2" fill="#FFFFFF" cx="14.6057895" cy="15" rx="6.31578947" ry="10" />
      )}
      {shape === 'triangle' && (
        <polygon
          transform="translate(-2, -2) scale(1.2, 1.2)"
          id="Triangle"
          fill="#FFFFFF"
          points="13.79 5 21.29 20 6.29 20"
        />
      )}
      {shape === 'charter' && (
        <path
          transform="translate(-2.5, -2) scale(1.2, 1.2)"
          d="M14.3117391,6 L20.748,14.13 L21.3334783,14.1304348 L21.04,14.5 L21.3334783,14.8695652 L20.748,14.869 L14.3117391,23 L7.875,14.869 L7.29,14.8695652 L7.583,14.5 L7.29,14.1304348 L7.875,14.13 L14.3117391,6 Z"
          id="Combined-Shape"
          fill="#FFFFFF"
        />
      )}
      {shape === 'square' && <rect id="Rectangle" fill="#FFFFFF" x="6.29" y="7" width="16" height="16" />}
      {shape === 'familychildcare' && (
        <polygon
          transform="translate(.8, 0)"
          id="Rectangle-Copy-3"
          fill="#FFFFFF"
          points="11.4624138 7 21.29 7 16.1175862 22 6.29 22"
        />
      )}
      {shape === 'transfer' && (
        <g id="Group-12">
          <path
            d="M14.559342,0 C22.5883428,0 29.1186841,6.53223753 29.1186841,14.5638185 C29.1186841,18.9926971 26.872601,23.9103293 22.7082129,29.1108647 C21.3343387,30.8263508 19.8659476,32.4277498 18.3591762,33.8755604 C16.3878086,35.7712594 15.6526085,36.2758056 14.7272943,36.285573 L14.4383681,36.2821621 L14.2650504,36.2583792 L14.0770371,36.2136141 L13.6928473,36.1221404 L13.3119872,36.0314594 L13.31,35.846 L13.2163961,35.787342 C11.7028406,34.8002056 9.06919248,32.1848616 6.91866305,29.6064651 L6.68178493,29.3202133 L6.48543544,29.0792006 C2.27148797,23.8745131 0,18.9683885 0,14.559342 C0,6.53128931 6.53128931,0 14.559342,0 Z M14.559342,1 C7.08357406,1 1,7.08357406 1,14.559342 C1,18.6993755 3.17950956,23.4068385 7.26167462,28.4487639 L7.45588325,28.6871506 C9.72480473,31.451011 12.6732211,34.3642842 14.0002692,35.0949417 L14.0335486,35.1117626 L14.269,35.231 L14.3086576,35.2408079 L14.4391635,35.275387 L14.4966709,35.285601 L14.7220016,35.285601 C15.2829475,35.2796628 15.8884095,34.864152 17.6661783,33.1546208 C19.1422305,31.7363273 20.5812976,30.1669085 21.9276539,28.4857825 C25.9630407,23.4463455 28.1186841,18.7267243 28.1186841,14.5638185 C28.1186841,7.08445729 22.035993,1 14.559342,1 Z"
            id="Shape-Copy-8"
            fill="#979797"
          />
          <polygon
            id="Path"
            fill="#979797"
            points="14.7240183 6.93540911 15.0293331 7.13305902 21.7865229 11.5074223 22.230139 11.7946035 21.9706241 12.2549515 15.2134343 24.2413875 14.7240183 25.1095521 14.2346023 24.2413875 7.4774125 12.2549515 7.21789763 11.7946035 7.66151365 11.5074223 14.4187035 7.13305902"
          />
          <polygon
            id="Path"
            fill="#FFFFFF"
            points="14.723361 8.27326079 8.71518215 12.1622279 14.723361 22.8200877 20.7315398 12.1622279"
          />
        </g>
      )}
      {shape === 'infant' && (
        <polygon
          transform="translate(-1.45, -3) scale(1.2, 1.2)"
          id="Path"
          fill="#FFFFFF"
          points="13.3284754 7 6.8407793 10.7623524 6.8407793 18.2376475 13.3284754 22 19.8161503 18.2376475 19.8161503 10.7623524"
        />
      )}
      {shape === 'specialized' && (
        <g id="Group-17" transform="translate(.8, 0)">
          <path
            d="M22.97,14.0029209 C22.97,9.03074499 18.7883396,5 13.63,5 C8.47166044,5 4.29,9.03074499 4.29,14.0029209 C22.2623132,14.1139093 4.9956028,13.8275618 22.97,14.0029209 Z"
            id="Oval-Copy"
            fill="#FFFFFF"
          />
        </g>
      )}
      {shape === 'multipleEligibilityShape' && (
        <g id="Group-17" transform="translate(0, -0)">
          <path
            d="M6.154781,26.6397199 C8.30641301,29.3006505 11.8900608,32.926568 12.9622684,33.2657567 L13.0045381,33.2791593 L13.0529936,33.2905 L13.2158867,33.2905 C13.5756949,33.2874071 14.0540644,32.9801784 15.6180442,31.4863045 L15.8108354,31.3017611 C17.1913027,29.9759351 18.6315662,28.4253579 20.0316219,26.6778657 C20.856397,25.6479278 21.5780752,24.6190209 22.2523288,23.591145 L3.93304311,23.591145 C4.60832771,24.6056183 5.33103688,25.6221536 6.154781,26.6397199"
            id="Fill-1"
            fill="#6095C8"
          />
          <path
            d="M26.1165032,13.062891 C26.1165032,11.7587153 25.9185572,10.5019643 25.5618419,9.31222624 L25.5443155,9.31222624 C25.7453544,9.98029406 25.9030926,10.6669193 25.9948489,11.374164 L0.121654326,11.374164 C0.213410554,10.6669193 0.370117821,9.98029406 0.571156749,9.31222624 L0.553630278,9.31222624 C0.197946021,10.4999024 0,11.7566534 0,13.0587671 C0,15.7269145 0.976327511,18.5961008 2.64340416,21.5292072 C2.76505848,21.7436488 2.87949603,21.9570593 3.0093981,22.1725318 C3.02898651,22.2044918 3.04754395,22.2364519 3.06713236,22.2694429 C3.3341533,22.7086356 3.61354586,23.1498903 3.90943392,23.591145 L3.9331462,23.591145 L22.2524319,23.591145 L22.2771751,23.591145 C22.5699703,23.1467974 22.8473009,22.7045117 23.111229,22.2622261 C23.1256625,22.2385138 23.1390651,22.2137706 23.1534987,22.1900583 C23.2844317,21.9684 23.4009312,21.7488036 23.5236165,21.5292072 C25.1587331,18.6043486 26.1165032,15.7372242 26.1165032,13.062891"
            id="Fill-7"
            fill="#F59524"
          />
          <path
            d="M25.9946427,11.3746794 C25.9028864,10.6674348 25.7451482,9.98080954 25.5441093,9.31274172 C23.929612,3.93520814 18.9531253,0 13.0580454,0 C7.16296545,0 2.18544779,3.93623911 0.570950555,9.31274172 C0.370942596,9.98080954 0.21320436,10.6674348 0.121448132,11.3746794 L25.9946427,11.3746794 Z"
            id="Fill-10"
            fill="#7BB041"
          />
          <path
            d="M13.6659651,0 C21.2016907,0 27.3319303,6.13163665 27.3319303,13.6703118 C27.3319303,18.0590449 24.966775,22.8104038 21.2108001,27.5009081 C19.8235826,29.2330553 18.3971501,30.7677829 17.0291005,32.0823001 C15.1784617,33.8619043 14.5419138,34.283353 13.8291938,34.290897 L13.6051122,34.290897 L13.489302,34.2773001 L13.3067432,34.2338337 L12.9225534,34.14236 L12.922,34.065 L12.8869122,34.0460471 C11.4087619,33.2258103 8.43761667,30.2039858 6.38776238,27.7080208 L6.19234647,27.4682089 C2.39226915,22.7746965 0,18.033352 0,13.6659651 C0,6.13093806 6.13093806,0 13.6659651,0 Z M13.6659651,1 C6.68322281,1 1,6.68322281 1,13.6659651 C1,17.7473128 3.30117533,22.3081145 6.96979076,26.8392573 C9.05646593,29.4206457 12.5330651,32.9376866 13.5731891,33.2663148 L13.614,33.279 L13.661,33.29 L13.8189248,33.290725 C14.1679982,33.2871402 14.6315259,32.9889967 16.1488992,31.5407281 L16.3361026,31.3613605 C17.6747601,30.0750853 19.0721464,28.571609 20.4302411,26.8758259 C24.0565577,22.3472404 26.3319303,17.776246 26.3319303,13.6703118 C26.3319303,6.6838704 20.6493549,1 13.6659651,1 Z"
            id="Mask"
            fill="#000000"
            fillRule="nonzero"
          />
        </g>
      )}
      {shape === 'multipleEligibilityShape-favorite' && (
        <g id="Group-17" transform="translate(0, -0)">
          <path
            d="M6.154781,26.6397199 C8.30641301,29.3006505 11.8900608,32.926568 12.9622684,33.2657567 L13.0045381,33.2791593 L13.0529936,33.2905 L13.2158867,33.2905 C13.5756949,33.2874071 14.0540644,32.9801784 15.6180442,31.4863045 L15.8108354,31.3017611 C17.1913027,29.9759351 18.6315662,28.4253579 20.0316219,26.6778657 C20.856397,25.6479278 21.5780752,24.6190209 22.2523288,23.591145 L3.93304311,23.591145 C4.60832771,24.6056183 5.33103688,25.6221536 6.154781,26.6397199"
            id="Fill-1"
            fill="#6095C8"
          />
          <path
            d="M26.1165032,13.062891 C26.1165032,11.7587153 25.9185572,10.5019643 25.5618419,9.31222624 L25.5443155,9.31222624 C25.7453544,9.98029406 25.9030926,10.6669193 25.9948489,11.374164 L0.121654326,11.374164 C0.213410554,10.6669193 0.370117821,9.98029406 0.571156749,9.31222624 L0.553630278,9.31222624 C0.197946021,10.4999024 0,11.7566534 0,13.0587671 C0,15.7269145 0.976327511,18.5961008 2.64340416,21.5292072 C2.76505848,21.7436488 2.87949603,21.9570593 3.0093981,22.1725318 C3.02898651,22.2044918 3.04754395,22.2364519 3.06713236,22.2694429 C3.3341533,22.7086356 3.61354586,23.1498903 3.90943392,23.591145 L3.9331462,23.591145 L22.2524319,23.591145 L22.2771751,23.591145 C22.5699703,23.1467974 22.8473009,22.7045117 23.111229,22.2622261 C23.1256625,22.2385138 23.1390651,22.2137706 23.1534987,22.1900583 C23.2844317,21.9684 23.4009312,21.7488036 23.5236165,21.5292072 C25.1587331,18.6043486 26.1165032,15.7372242 26.1165032,13.062891"
            id="Fill-7"
            fill="#F59524"
          />
          <path
            d="M25.9946427,11.3746794 C25.9028864,10.6674348 25.7451482,9.98080954 25.5441093,9.31274172 C23.929612,3.93520814 18.9531253,0 13.0580454,0 C7.16296545,0 2.18544779,3.93623911 0.570950555,9.31274172 C0.370942596,9.98080954 0.21320436,10.6674348 0.121448132,11.3746794 L25.9946427,11.3746794 Z"
            id="Fill-10"
            fill="#7BB041"
          />
          <path
            d="M13.1659651,0 C5.90708043,0 0,5.90708043 0,13.1659651 C0,18.108092 3.30779118,23.2284311 6.08094593,26.6535815 C7.51098969,28.4226629 11.5055496,32.7953803 12.9225534,33.243084 L12.9225534,33.2474306 L13.1051122,33.290897 L13.2659378,33.290897 C13.6919083,33.290897 14.030946,33.290897 16.1825316,31.2218975 C17.1822582,30.2612906 18.7122747,28.6965011 20.3205305,26.6883546 C23.0632588,23.2632042 26.3319303,18.1385185 26.3319303,13.1703118 C26.3319303,5.90708043 20.4248499,0 13.1659651,0 Z"
            id="Mask"
            stroke="#000000"
            fillRule="nonzero"
          />
          <polygon
            transform="translate(.8, 0)"
            id="Star"
            fill="#FFFFFF"
            points="13.5 18.25 9.09161061 20.5676275 9.93353806 15.6588137 6.36707613 12.1823725 11.2958053 11.4661863 13.5 7 15.7041947 11.4661863 20.6329239 12.1823725 17.0664619 15.6588137 17.9083894 20.5676275"
          />
        </g>
      )}
      {shape === 'multipleEligibilityShape-applied' && (
        <g id="Group-17" transform="translate(0, -0)">
          <path
            d="M6.154781,26.6397199 C8.30641301,29.3006505 11.8900608,32.926568 12.9622684,33.2657567 L13.0045381,33.2791593 L13.0529936,33.2905 L13.2158867,33.2905 C13.5756949,33.2874071 14.0540644,32.9801784 15.6180442,31.4863045 L15.8108354,31.3017611 C17.1913027,29.9759351 18.6315662,28.4253579 20.0316219,26.6778657 C20.856397,25.6479278 21.5780752,24.6190209 22.2523288,23.591145 L3.93304311,23.591145 C4.60832771,24.6056183 5.33103688,25.6221536 6.154781,26.6397199"
            id="Fill-1"
            fill="#6095C8"
          />
          <path
            d="M26.1165032,13.062891 C26.1165032,11.7587153 25.9185572,10.5019643 25.5618419,9.31222624 L25.5443155,9.31222624 C25.7453544,9.98029406 25.9030926,10.6669193 25.9948489,11.374164 L0.121654326,11.374164 C0.213410554,10.6669193 0.370117821,9.98029406 0.571156749,9.31222624 L0.553630278,9.31222624 C0.197946021,10.4999024 0,11.7566534 0,13.0587671 C0,15.7269145 0.976327511,18.5961008 2.64340416,21.5292072 C2.76505848,21.7436488 2.87949603,21.9570593 3.0093981,22.1725318 C3.02898651,22.2044918 3.04754395,22.2364519 3.06713236,22.2694429 C3.3341533,22.7086356 3.61354586,23.1498903 3.90943392,23.591145 L3.9331462,23.591145 L22.2524319,23.591145 L22.2771751,23.591145 C22.5699703,23.1467974 22.8473009,22.7045117 23.111229,22.2622261 C23.1256625,22.2385138 23.1390651,22.2137706 23.1534987,22.1900583 C23.2844317,21.9684 23.4009312,21.7488036 23.5236165,21.5292072 C25.1587331,18.6043486 26.1165032,15.7372242 26.1165032,13.062891"
            id="Fill-7"
            fill="#F59524"
          />
          <path
            d="M25.9946427,11.3746794 C25.9028864,10.6674348 25.7451482,9.98080954 25.5441093,9.31274172 C23.929612,3.93520814 18.9531253,0 13.0580454,0 C7.16296545,0 2.18544779,3.93623911 0.570950555,9.31274172 C0.370942596,9.98080954 0.21320436,10.6674348 0.121448132,11.3746794 L25.9946427,11.3746794 Z"
            id="Fill-10"
            fill="#7BB041"
          />
          <path
            d="M13.1659651,0 C5.90708043,0 0,5.90708043 0,13.1659651 C0,18.108092 3.30779118,23.2284311 6.08094593,26.6535815 C7.51098969,28.4226629 11.5055496,32.7953803 12.9225534,33.243084 L12.9225534,33.2474306 L13.1051122,33.290897 L13.2659378,33.290897 C13.6919083,33.290897 14.030946,33.290897 16.1825316,31.2218975 C17.1822582,30.2612906 18.7122747,28.6965011 20.3205305,26.6883546 C23.0632588,23.2632042 26.3319303,18.1385185 26.3319303,13.1703118 C26.3319303,5.90708043 20.4248499,0 13.1659651,0 Z"
            id="Mask"
            stroke="#000000"
            fillRule="nonzero"
          />
          <path
            transform="translate(.8, 0)"
            d="M19.1596557,10.0180675 C19.6213282,9.50479381 20.4116782,9.46296278 20.9249519,9.92463524 C21.4382255,10.3863077 21.4800566,11.1766577 21.0183841,11.6899314 L14.1410624,19.3359324 L13.3520865,20.2130922 L12.4308294,19.4760864 L8.00913119,15.9387279 C7.47005377,15.507466 7.38265205,14.7208505 7.81391399,14.1817731 C8.24517592,13.6426957 9.03179139,13.5552939 9.57086881,13.9865559 L13.071,16.7869994 L19.1596557,10.0180675 Z"
            id="Line-2"
            fill="#FFFFFF"
          />
        </g>
      )}
      {shape === 'favorite' && (
        <polygon
          id="Star"
          transform="translate(.8, 0)"
          fill="#FFFFFF"
          points="13.5 18.25 9.09161061 20.5676275 9.93353806 15.6588137 6.36707613 12.1823725 11.2958053 11.4661863 13.5 7 15.7041947 11.4661863 20.6329239 12.1823725 17.0664619 15.6588137 17.9083894 20.5676275"
        />
      )}
      {shape === 'checkmark' && (
        <path
          d="M8 16.5L13 21.5L22 10.5"
          transform="translate(.8, 0)"
          stroke="#ffffff"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      )}
      {shape === 'applied' && (
        <path
          transform="translate(.8, 0)"
          d="M19.1596557,10.0180675 C19.6213282,9.50479381 20.4116782,9.46296278 20.9249519,9.92463524 C21.4382255,10.3863077 21.4800566,11.1766577 21.0183841,11.6899314 L14.1410624,19.3359324 L13.3520865,20.2130922 L12.4308294,19.4760864 L8.00913119,15.9387279 C7.47005377,15.507466 7.38265205,14.7208505 7.81391399,14.1817731 C8.24517592,13.6426957 9.03179139,13.5552939 9.57086881,13.9865559 L13.071,16.7869994 L19.1596557,10.0180675 Z"
          id="Line-2"
          fill="#FFFFFF"
        />
      )}
      {shape.includes('number$$') && (
        <g id="Group-2" transform="translate(3.29, 4)">
          <circle id="Oval" fill="#000000" cx="11" cy="10" r="10" />
          <text
            id="3"
            fontFamily="Arial-BoldMT, Arial"
            fontSize="11.5"
            fontWeight="bold"
            fill="#FFFFFF"
            textAnchor="middle"
          >
            <tspan x="11" y="13.5613388">
              {shape.split('$$').pop()}
            </tspan>
          </text>
        </g>
      )}
      {shape === 'circle' && (
        <g id="Group-2" transform="translate(7.29, 6)" fill="#FFFFFF">
          <circle id="Oval" cx="7" cy="8" r="6" />
        </g>
      )}
      {shape === 'd75' && (
        <polygon
          transform="translate(-2, -2) scale(1.2, 1.2)"
          id="Triangle"
          fill="#FFFFFF"
          points="13.79 23 21.29 9 6 11"
        />
      )}
       {
        shape == "affiliatedSchoolShape" &&
        <path fill="#FFFFFF" transform="translate(-2, 0)" d="M 16.980469 6.332031 C 19.375 6.332031 21.335938 8.171875 21.503906 10.5 L 21.515625 10.820312 C 24.019531 10.820312 26.046875 12.828125 26.046875 15.304688 C 26.046875 17.78125 24.019531 19.792969 21.515625 19.792969 C 21.515625 22.269531 19.484375 24.277344 16.980469 24.277344 C 14.476562 24.277344 12.449219 22.269531 12.449219 19.792969 L 12.449219 19.789062 C 9.945312 19.792969 7.914062 17.78125 7.914062 15.304688 C 7.914062 12.828125 9.945312 10.820312 12.449219 10.820312 L 12.449219 10.816406 L 12.460938 10.5 C 12.625 8.171875 14.585938 6.332031 16.980469 6.332031 Z M 16.980469 6.332031 "/>
      }
    </>
  );
};

ShapeComponent.propTypes = {
  shape: PropTypes.string,
};

export default MapPin;
